
import { Component, Getter, Action, Prop, mixins } from "nuxt-property-decorator"
import { ValidationProvider } from "vee-validate"
import Blocks from "~/mixins/blocks"
import {
  SET_PICKUP_PROPERTY_TYPE,
  SET_DELIVERY_PROPERTY_TYPE,
  SET_LISTING
} from "~/store/listing/actions"
import { GET_PICKUP_PROPERTY_TYPE, GET_DELIVERY_PROPERTY_TYPE } from "~/store/listing/getters"
import InitialListing from "~/store/listing/state"
import PropertyTypeSelect from "~/components/parts/PropertyTypeSelect.vue"
import {
  FLAT,
  FLATSHARE,
  FOUR_BED_FLAT,
  FOUR_BED_HOUSE,
  HOUSE,
  ONE_BED_FLAT,
  ONE_BED_HOUSE,
  PROPERTY_TYPE_LIST_FLAT,
  PROPERTY_TYPE_LIST_HOUSE,
  PROPERTY_TYPE_LIST_MAIN,
  STORAGE,
  STUDIO,
  THREE_BED_FLAT,
  THREE_BED_HOUSE,
  TWO_BED_FLAT,
  TWO_BED_HOUSE
} from "~/constants/listing"

// Using ValidationProvider without validating anything is a workaround!
// ValidationProvider must be added as container for the main Sel items
// To allow subMenu Sel items using their own props
@Component({
  components: { PropertyTypeSelect, ValidationProvider }
})
export default class PropertyInput extends mixins(Blocks) {
  getPropertyTypesMain: any[] = PROPERTY_TYPE_LIST_MAIN
  getPropertyTypesHouse: any[] = PROPERTY_TYPE_LIST_HOUSE
  getPropertyTypesFlat: any[] = PROPERTY_TYPE_LIST_FLAT

  @Prop({ required: true, type: Object }) block: Record<string, any>
  @Prop({ default: false, type: Boolean }) virgin: boolean
  @Prop({ default: true, type: Boolean }) lazy: boolean

  @Getter(GET_PICKUP_PROPERTY_TYPE, { namespace: "listing" }) getPickupPropertyType: string | null
  @Getter(GET_DELIVERY_PROPERTY_TYPE, { namespace: "listing" }) getDeliveryPropertyType:
    | string
    | null

  @Action(SET_PICKUP_PROPERTY_TYPE, { namespace: "listing" }) setPickupPropertyType: Function
  @Action(SET_DELIVERY_PROPERTY_TYPE, { namespace: "listing" }) setDeliveryPropertyType: Function
  @Action(SET_LISTING, { namespace: "listing" }) setListing: Function

  created() {
    this.setListing(InitialListing())
  }

  isHouse(propertyType) {
    return (
      propertyType === HOUSE ||
      (propertyType !== "" &&
        this.getPropertyTypesHouse.find(option => option.value === propertyType))
    )
  }

  isFlat(propertyType) {
    return (
      propertyType === FLAT ||
      (propertyType !== "" &&
        this.getPropertyTypesFlat.find(option => option.value === propertyType))
    )
  }

  get attributes() {
    return this.virgin ? null : this.Blocks_getAttributes(this.block)
  }

  get pickupPropertyType(): string | null {
    return this.getPickupPropertyType
  }

  set pickupPropertyType(value) {
    this.setPickupPropertyType(value)
  }

  get deliveryPropertyType(): string | null {
    return this.getDeliveryPropertyType
  }

  set deliveryPropertyType(value) {
    this.setDeliveryPropertyType(value)
  }

  get pickupIcon(): string {
    return this.iconByPropertyType(this.pickupPropertyType)
  }

  get deliveryIcon(): string {
    return this.iconByPropertyType(this.deliveryPropertyType)
  }

  iconByPropertyType(propertyType: string | null): string {
    let icon = "property-type"

    switch (propertyType) {
      case ONE_BED_HOUSE:
      case TWO_BED_HOUSE:
      case THREE_BED_HOUSE:
      case FOUR_BED_HOUSE:
        icon = "house"
        break
      case ONE_BED_FLAT:
      case TWO_BED_FLAT:
      case THREE_BED_FLAT:
      case FOUR_BED_FLAT:
      case STUDIO:
        icon = "flat"
        break
      case STORAGE:
        icon = "storage-unit"
        break
      case FLATSHARE:
        icon = "flatshare"
        break
      default:
        break
    }

    return icon
  }
}
